<template lang="pug">
    .footer(
    )
        ScrollTrigger(
            :color='"black"',
            )

        .footer__wrapper
            .footer__text(v-observe-visibility='{callback: visibilityChanged}')
                p.footer__par(v-for='(par, index) in articleText.split("<br>")')
                    span.footer__word(ref='word' v-for='(word, index) in par.split(" ")' v-html='word')
        .footer__links
            router-link.footer__link.footer__link_prev(
                v-if='prevArticle',
                :to='`/${categoryId}/${sectionId}/${prevArticle}`'
                ) предыдующая глава
            router-link.footer__link.footer__link_next(
                v-if='nextArticle',
                :to='`/${categoryId}/${sectionId}/${nextArticle}`'
                ) следующая глава
</template>
<script>
import menuData from '@/assets/data/menu';
import {gsap} from 'gsap';

export default {
    components: {
        ScrollTrigger: () => import('../components/ScrollTrigger.vue')
    },

    data() {
        return {
            nextArticle: null,
            prevArticle: null,
            articleText: this.$store.getters.getArticle(this.articleId, this.sectionId, this.categoryId).footer.text,
            articleTextType: '',
            intervalID: null
        };
    },
    props: {
        articleId: String,
        sectionId: String,
        categoryId: String,
        theme: String
    },

    watch: {
        articleId() {
            this.setArticleText();
            this.setNextArticleLink();
            this.setPrevArticleLink();
        }
    },

    mounted() {
        this.setNextArticleLink();
        this.setPrevArticleLink();
    },
    // computed: {
    //     articleTextArr() {
    //         return this.articleText.split(' ');
    //     }
    // },

    methods: {
        setNextArticleLink() {
            const curCategory = menuData[this.categoryId].articles;
            const curSection = curCategory.find(section => section.id === this.sectionId).articles;
            this.nextArticle = null;
            curSection.forEach((article, index) => {
                if (article.id === this.articleId && index < curSection.length - 1) {
                    this.nextArticle = curSection[index + 1].id;
                }
            });
        },
        setPrevArticleLink() {
            const curCategory = menuData[this.categoryId].articles;
            const curSection = curCategory.find(section => section.id === this.sectionId).articles;
            this.prevArticle = null;
            curSection.forEach((article, index) => {
                if (article.id === this.articleId && index > 0) {
                    this.prevArticle = curSection[index - 1].id;
                }
            });
        },
        setArticleText() {
            this.articleText = this.$store.getters.getArticle(this.articleId, this.sectionId, this.categoryId).footer.text;
        },
        visibilityChanged(isVisible) {
            if (!isVisible) this.destroyAnimation();
            if (isVisible) this.createAnimation();
        },
        createAnimation() {
            this.timeline = gsap.timeline();
            this.timeline
                .set(this.$refs.word, {opacity: 0, x: '-10', y: '-2'})
                .to(this.$refs.word, {duration: 0.8, opacity: 1, x: '0', y: '0', stagger: {amount: 2, from: 'center', grid: 'auto'}});
        },
        destroyAnimation() {
            if (this.timeline) {
                this.timeline.kill();
                this.timeline = null;
            }
            this.isInited = false;
        }
    },
    beforeUpdate() {
        this.destroyAnimation();
    }
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.footer {
    position: relative;
    background: black;
    width: 100%;
    //display: flex;
    color: var(--theme);
    padding: 80px 0 180px;
    overflow: hidden;
    @media (--viewport-laptop) {
        padding: 30px 0 80px;
    }
    &__word {
        padding-right: 0.5rem;
    }

    &__wrapper {
        position: relative;
        margin: auto;
        width: calc(var(--grid-column) * 17);

        @media (--viewport-laptop) {
            width: 100%;
            padding: 0 calc(var(--grid-column-laptop) * 1);
        }

        &::before,
        &::after {
            content: '';
            position: absolute;
            left: 0;
            height: 4px;
            width: calc(var(--grid-column) * 17);
            //background: url('../assets/img/article-intro/border.svg') center / 8px 4px repeat-x;
            border-bottom: 5px dotted var(--theme);

            @media (--viewport-laptop) {
                width: calc(var(--grid-column-laptop) * 23);
                margin-left: var(--grid-column-laptop);
            }

            @media screen and (--viewport-tablet) {
                width: 100%;
                margin: auto;
            }
        }

        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 11);
            margin-left: var(--grid-column-mobile);
        }
    }

    &__text {
        font-family: var(--font-accent);
        font-weight: 400;
        font-size: 1.25rem;
        line-height: 1.4;
        position: relative;
        padding: 25px 0 21px;

        @media (--viewport-tablet) {
            font-size: 1rem;
            font-weight: 400;
            //font-family: var(--font-main);
        }
    }
    &__par {
        display: flex;
        flex-wrap: wrap;
    }
    &__links {
        margin: auto;
        width: calc(var(--grid-column) * 17);
        padding: 80px 0 0 0;
        display: flex;
        @media (--viewport-laptop) {
            width: 100%;
            padding: 80px calc(var(--grid-column-laptop) * 1) 0;
        }
        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 11);
            padding: 20px 0 0 0;
        }
    }

    &__link {
        color: white;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: bold;
        &_prev {
            margin-right: auto;
        }
        &_next {
            margin-left: auto;
        }

        @media screen and (--viewport-tablet) {
            font-size: 11.5px;
            font-weight: 700;
        }
    }
}
</style>
